export const SCRIBENOTE_PRO_FEATURES = [
  "Most advanced AI models for more accurate notes",
  "Highest Quality Transcription for fewer word errors",
  "Custom Adaptive Templates",
  "AI Writing Assistant",
  "Client Summaries",
  "Desktop Widget PIMS Transfer",
  "Priority Human Support",
  "Multilingual Transcription",
];
